'use client';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export function LandingLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20 sm:pt-28 lg:pt-80">{children}</main>
      <Footer />
    </div>
  );
}
